// KPS web sitesi rota anahtarları (API Site_model::link ile çözülür).
//   "urunlerimiz"        → sayfa
//   "uretim#3"           → üretim sayfasında 3. adım
//   "page:<içerik slug>" → Sabit İçerikler'deki sayfa (dile göre slug)
export default [
  'index',
  'urunlerimiz',
  'uretim',
  'uretim#1',
  'haberler',
  'iletisim',
  'kariyer',
  'yedek-parca',
  'surdurulebilirlik',
  'page:hakkimizda',
  'page:sertifikalar',
  'page:referanslar',
  'page:arge',
  'page:kvkk',
]
